import { IconButton, Table } from "rsuite";
import { FiFilter } from "react-icons/fi";


function FilterableHeaderCell({ 
  children, 
  columnKey, 
  hasActiveFilters, 
  onFilterClick,
  ...props 
}) {
  const { HeaderCell } = Table;
  
  // Handle both boolean and array values for hasActiveFilters
  const isActive = Array.isArray(hasActiveFilters) 
    ? hasActiveFilters.length > 0 
    : Boolean(hasActiveFilters);
  
  return (
    <HeaderCell {...props} style={{ padding: "0 10px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between", // Ensures icon is to the right
          width: "100%",
          height: "100%" 
        }}
      >
        <span style={{ flexGrow: 1 }}>{children}</span>
        <IconButton
          data-testid={`filter-icon-${columnKey}`}
          icon={<FiFilter />}
          appearance={isActive ? "primary" : "subtle"}
          circle
          size="xs"
          onClick={(e) => {
            e.stopPropagation(); // Prevent sorting when clicking filter icon
            if (onFilterClick) onFilterClick(columnKey);
          }}
          style={{
            color: isActive ? "#1675e0" : "inherit",
          }}
        />
      </div>
    </HeaderCell>
  );
}

export default FilterableHeaderCell;
